import { helper } from '@ember/component/helper';

import { get } from 'rise-ui/utils/object.js';

export default helper(function findHelper([ haystack, needle, path ]) {
  return haystack?.find?.(hay => (path ? get(hay, path) : hay) === needle);
});
